"use strict";

const ADDRESS = {
  CAPSULE_JS_MEMORY: 'CAPSULE-JS-MEMORY',
  CAPSULE_JS_CACHE: 'CAPSULE-JS-CACHE',
  MAINTAINER: 'KAMBRIA-BRIDGE-REACT-MAINTAINER',
  BEACON: 'KAMBRIA-BRIDGE-REACT-BEACON',
  PORTER: 'KAMBRIA-BRIDGE-REACT-PORTER',
  EVENT: 'KAMBRIA-BRIDGE-REACT-EVENT'
};
module.exports = ADDRESS;